// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2rBmt","menuItem":"_Wtcz"};